import { Firestore } from '../../config/firebase';
import { collection, doc, getDoc, getDocs, query, where, orderBy, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';

const teamsDb = () => {
  const add = async teamInfo => {
    const teamsRef = collection(Firestore, 'teams');
    return addDoc(teamsRef, teamInfo);
  }

  const update = async (teamId, teamInfo) => {
    const teamRef = doc(Firestore, 'teams', teamId);
    return updateDoc(teamRef, teamInfo);
  }

  const remove = async teamId => {
    const teamRef = doc(Firestore, 'teams', teamId);
    return deleteDoc(teamRef);
  }

  const findOne = async teamId => {
    const teamRef = doc(Firestore, 'teams', teamId);
    return getDoc(teamRef);
  }

  const findAll = companyId => {
    const teamsRef = collection(Firestore, 'teams');
    return query(
      teamsRef,
      where('companyId', '==', companyId),
      orderBy('name')
    );
  }

  return Object.freeze({
    add,
    update,
    findOne,
    findAll,
    remove
  })
}

const Teams = teamsDb();

export { Teams }
